import PageMeta from 'public/components/default_template/meta/PageMeta'
import React from 'react'
import { useParams } from 'react-router'
import { useEditor } from '@toasttab/sites-components'

import { Channel } from 'src/public/js/siteUtilities'
import {
  EcommercePageLayout,
  EcommercePageLayoutChildProps
} from '../online_ordering/pages/EcommercePageLayout'
import { EcommPageContent } from '../EcommPage'
import { EcommercePage } from 'src/apollo/sites'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { useOOMenus } from 'public/components/online_ordering/useOOMenu'
import { useCategoryFromSlug } from '../menu_banner/useCategoryFromSlug'
import { DisplayPageContextProvider } from '../DisplayPageContext'

type EcommCategoryPagePageContentProps = {
  categorySlug: string
  ecommContent: EcommercePage
  urlFilters?: Set<string>
  updateFiltersURL?: (filters: Set<string>, replace?: boolean) => void
} & EcommercePageLayoutChildProps

const CategoryDisplayPageContent = (
  props: EcommCategoryPagePageContentProps
) => {
  const { selectedLocation } = useRestaurant()
  const { isEditor } = useEditor()
  const channelGuid = selectedLocation?.ecommMenuChannelGuid || undefined

  // Fetch menu groupings to get category information
  const { groupings } = useOOMenus({
    respectAvailability: !isEditor,
    channelGuid,
    requirePagination: true,
    skipPopularItems: true,
    categorySlug: props.categorySlug
  })

  // Get the category from the slug
  const category = useCategoryFromSlug(props.categorySlug, groupings)

  // Use the category name for the page title, fallback to slug if not found
  const pageMetaTitle = category?.name || props.categorySlug || 'Category'
  const pageMetaDescription = category?.name
    ? `Browse our ${category.name} products`
    : 'Category Display Page Description'

  return (
    <>
      <PageMeta title={pageMetaTitle} description={pageMetaDescription} />
      <EcommPageContent {...props} />
    </>
  )
}

const CategoryDisplayPage = ({
  ecommContent
}: {
  ecommContent: EcommercePage
}) => {
  const { categorySlug } = useParams<{ categorySlug: string }>()

  return (
    <DisplayPageContextProvider channel={Channel.ECOMM}>
      <EcommercePageLayout>
        {(props) => (
          <CategoryDisplayPageContent
            {...props}
            ecommContent={ecommContent}
            categorySlug={categorySlug || ''}
          />
        )}
      </EcommercePageLayout>
    </DisplayPageContextProvider>
  )
}

export default React.memo(CategoryDisplayPage)
